// Port of api/fuel/app/classes/controller/api/monty/tags/family/delete.php
import DB from 'offline/db'
import {
	familyToArray,
	loadOwnedFamily,
	persist,
	sessionUserId,
	unauthorised
} from '../shared'

export default function(params) {
	var userId = sessionUserId(params)
	var family = false
	var payload = false
	var tags = []

	if (!userId) {
		return unauthorised()
	}

	family = loadOwnedFamily(userId, params.family)
	if (!family) {
		return unauthorised()
	}

	payload = familyToArray(family)
	tags = DB.query('SELECT tag_id FROM tag WHERE family_id = ?', [parseInt(family.family_id, 10) || 0]).map(function(row) {
		return parseInt(row.tag_id, 10) || 0
	}).filter(Boolean)

	if (tags.length) {
		DB.run('DELETE FROM tag_attach WHERE tag_id IN (' + tags.map(function() { return '?' }).join(', ') + ')', tags)
		DB.run('DELETE FROM tag WHERE family_id = ?', [parseInt(family.family_id, 10) || 0])
	}

	DB.run('DELETE FROM tag_family WHERE family_id = ?', [parseInt(family.family_id, 10) || 0])
	return persist(payload)
}
